module.exports = __webpack_public_path__ + "vc.b102b9165841de5f2362.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/vc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/vc.svg
// module chunks = styles